<template>
  <div class="gallery-detail-wrapper">
    <h1 class="title">{{ galleryTitle }}</h1>
    <Masonary :folder="folder" :enablePagination="true" class="masonary" />
  </div>
</template>

<script>
import Masonary from "@/features/common/Masonary.vue";

export default {
  name: "GalleryDetail",
  components: {
    Masonary,
  },
  props: {
    albumKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      galleryTitle: this.albumKey,
      folder: this.albumKey,
    };
  },
  mounted() {
    window.scrollTo(0, 0);

    // 読み込み時にアニメーション
    const title = document.querySelector(".title");
    title.classList.add("loaded");

    // スクロール位置でタイトルのフェードインアウト
    window.addEventListener("scroll", this.handleScroll);

  },
  beforeDestroy() {
    // イベントリスナーのクリーンアップ
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const title = document.querySelector(".title");
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      if (scrollPosition < 100) {
        title.style.opacity = "1"; // フェードイン
        title.style.transition = "opacity 0.3s";
      } else {
        title.style.opacity = "0"; // フェードアウト
        title.style.transition = "opacity 0.3s";
      }
    },
  },
};
</script>


<style scoped>
.gallery-detail-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  row-gap: 150px;
  margin-top: 250px;
  margin-bottom: 100px;
}

.title {
  color: #525252;
  font-family: sans-serif;
  font-size: 30px;
  font-weight: normal;
  opacity: 0;
}

.title:is(.loaded) {
  transition: opacity 0.5s;
  opacity: 1;
}

.masonary {
  min-height: 80vh;
  width: 80%;
  height: auto;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {

  .gallery-detail-wrapper {
    row-gap: 100px;
    margin-top: 180px;
    margin-bottom: 100px;
  }
  .title {
    font-size: 15px;
  }
  .masonary {
    width: 95%;
  }

}

@media screen and (max-width: 570px) {

  .gallery-detail-wrapper {
    row-gap: 80px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
  .title {
    font-size: 13px;
  }
  .masonary {
    width: 98%;
  }
}
</style>